import React from 'react';

export const Notes = (props) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19 3H6C4.89543 3 4 3.89543 4 5V19C4 20.1046 4.89543 21 6 21H15.1153C15.6788 21 16.2161 20.7623 16.5951 20.3453L20.4799 16.0721C20.8146 15.704 21 15.2243 21 14.7268V5C21 3.89543 20.1046 3 19 3Z"
      stroke="black"
      strokeWidth="1.5"
    />
    <line
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      x1="8.75"
      x2="16.25"
      y1="7.25"
      y2="7.25"
    />
    <line
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      x1="8.75"
      x2="16.25"
      y1="10.25"
      y2="10.25"
    />
    <line
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      x1="8.75"
      x2="12.25"
      y1="13.25"
      y2="13.25"
    />
    <path
      d="M15 21V16C15 14.8954 15.8954 14 17 14H21"
      stroke="black"
      strokeWidth="1.5"
    />
  </svg>
);
